export const dashboardActividadesQueryKeys = {
  actividades(periodoId) {
    return ["dashboard", "actividades", { periodoId }];
  },
  actividad(periodoId, actividadId) {
    return ["dashboard", "actividad", { periodoId, actividadId }];
  },
  actividadesMeta(semestreId) {
    return ["dashboard", "actividades-meta", { semestreId }];
  },
  actividadesRosters(periodoId) {
    return ["dashboard", "actividades-rosters", { periodoId }];
  },
  encargos(periodoId, actividadId) {
    return ["dashboard", "actividad-encargos", { periodoId, actividadId }];
  },
  asistenciaSocios(periodoId, actividadId) {
    return ["dashboard", "actividad-asistencia-socios", { periodoId, actividadId }];
  },
  asistenciaInstructores(periodoId, actividadId) {
    return ["dashboard", "actividad-asistencia-instructores", { periodoId, actividadId }];
  },
  remplazos(periodoId, actividadId) {
    return ["dashboard", "actividad-remplazos", { periodoId, actividadId }];
  },
  preceptorias(periodoId, actividadId) {
    return ["dashboard", "actividad-preceptorias", { periodoId, actividadId }];
  },
  materialesCatalog(periodoId) {
    return ["dashboard", "materiales-catalog", { periodoId }];
  },
  categoriasGastosCatalog(periodoId) {
    return ["dashboard", "categorias-gastos-catalog", { periodoId }];
  },
  actividadMateriales(periodoId, actividadId) {
    return ["dashboard", "actividad-materiales", { periodoId, actividadId }];
  },
  actividadGastos(periodoId, actividadId) {
    return ["dashboard", "actividad-gastos", { periodoId, actividadId }];
  },
};

